import { gql } from '@apollo/client';

export default class DocumentTypeMutation {
    static CREATE_DOCUMENT_TYPE = gql`
        mutation createDocumentType($description: String!, $module: String!) {
            createDocumentType(description: $description, module: $module)
        }
    `;

    static UPDATE_DOCUMENT_TYPE = gql`
        mutation updateDocumentType($documentTypeId: Int!, $description: String!, $module: String!) {
            updateDocumentType(documentTypeId: $documentTypeId, description: $description, module: $module)
        }
    `;

    static DELETE_DOCUMENT_TYPE = gql`
        mutation deleteDocumentType($documentTypeId: Int!) {
            deleteDocumentType(documentTypeId: $documentTypeId)
        }
    `;

    static UPDATE_FILE_DOCUMENT_TYPE = gql`
        mutation updateFileDocumentType($documentId: Int!, $documentType: String!) {
            updateFileDocumentType(documentId: $documentId, documentType: $documentType)
        }
    `;
}
